/**
 * @license
 * Copyright 2022 Aglyn LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export function truth(...val: unknown[]): boolean {
  return val.some(Boolean)
}

/**
 * Shortcut for checking multiple truthy values e.g., `Boolean(i of val)`
 * @returns return true unless any value is falsy otherwise returns false
 */
export function truthy(...val: unknown[]): boolean {
  for (const i of val) {
    if (!i) return false
  }
  return true
}
export default truthy
